export default {
  infoTitle: '院校資源數據信息',
  infoDesc: '可查詢申請指引和申請費用資訊,同時查看學校相關的語言類型',
  infoTypeApplicationFee: '申請費詳細',
  infoTypeLanguageReq: '語言類型',
  schoolName: '院校名稱',
  majorLevel: '課程級別',
  keywordSearch: '關鍵字搜尋',
  searchResultEmpty: '請更改搜尋',
  search: '搜尋',
  reset: '重置',
  dataTotalNumber: '共{totalNumber}條數據',
  country: '國家',
  institutionName: '學校',
  serialNumber: '序號',
  applicationFeeFound: '免申請費?',
  applicationFee: '申請費',
  applicationFeeDetail: '部分專業內容',
  applicationLang: '語言類型',
  applicationLangGoDetail: '查看語言類型',
  operation: '操作',
  viewDetail: '查看詳細',
  yes: '是',
  no: '否',
  previous: '上一条',
  next: '下一条',
  viewApplicationFee: '查看申请费',
  viewLanguageReq: '查看语言类型',
  professionalDetail: '专业内容',
  matchCourseDetail: '符合條件課程',
  courseDetailDataTotalNumber: '共{totalNumber}条数据',
  langTypeDesc: '介绍',
  langTypeOptionPlaceholder: '是否有語言型別',
}
